import { LOCALES } from "../../i18n/locales";
import { LanguageType } from "./LocaleSelectorType";

export const languages: LanguageType[] = [
  { label: "RU", value: LOCALES.RUSSIAN, image: "/image/iconsFlag/russia.svg" },
  { label: "EN", value: LOCALES.ENGLISH, image: "/image/iconsFlag/uk.svg" },
  { label: "DE", value: LOCALES.GERMAN, image: "/image/iconsFlag/german.svg" },
];
